<template>
  <div class="kye-upload-container" :class="uploadWrapClass">
    <el-upload
      ref="upload"
      v-show="!isNewPictureCardMode"
      :action="uploadUrl"
      :headers="headers"
      :on-success="handleSuccess"
      :on-error="onError"
      :on-exceed="onExceed"
      :on-change="handleChange"
      :before-remove="beforeRemove"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="handleBeforeUpload"
      :list-type="innerListType"
      :show-file-list="showInnerFileList"
      :file-list="fileList"
      :drag="isDrag"
      :data="fileData"
      :accept="currentAccept"
      :disabled="disableUpload"
      v-bind="bindAtrr"
      v-on="$listeners">
      <upload-button
        :mode="buttonMode"
        :areaSize="areaSize"
        :loading="loading"
        :disabled="disableUpload"
        :auth="auth"
        :type="btnType"
        :icon="btnIcon"
        :text="btnText"
        :loadingText="loadingText"
        :limit="limitAtrr"
        :showLimit="showLimitText"
        :fileList="value"
        :title="title"
        :tips="tips">
        <template slot="upload">
          <slot name="default"></slot>
        </template>
      </upload-button>
      <template slot="tip">
        <slot name="tip"></slot>
      </template>
    </el-upload>

    <upload-list
      :class="uploadListWrapClass"
      :style="uploadListWrapStyle"
      :fileList="value"
      :uploadList="uploadList"
      :visible="showFileList"
      :mode="buttonMode"
      v-bind="previewAttrs"
      @remove="deleteFile">
      <template slot="upload" v-if="isNewPictureCardMode">
        <upload-button
          @upload="manualUpload"
          :mode="buttonMode"
          :areaSize="areaSize"
          :loading="loading"
          :disabled="disableUpload"
          :auth="auth"
          :type="btnType"
          :icon="btnIcon"
          :text="btnText"
          :loadingText="loadingText"
          :limit="limitAtrr"
          :showLimit="showLimitText"
          :fileList="value"
          :uploadList="uploadList"
          :title="title"
          :tips="tips">
        </upload-button>
      </template>
    </upload-list>
  </div>
</template>

<script>
  import UploadButton from './components/upload-button.vue'
  import UploadList from './components/upload-list.vue'
  import { getToken } from 'public/utils'
  import { isEncryptedByVideoFile } from 'public/utils/safety'
  import { ENV } from 'public/config'

  const isProd = ENV === 'prd'

  const BUTTON_TEXT = '上传文件'

  export default {
    name: 'kye-upload',
    components: {
      UploadButton,
      UploadList
    },
    props: {
      value: {
        type: Array,
        default: () => ([])
      },
      // layout: String, // 上传按钮位置，例如左边上传，右边预览
      code: String,
      id: String,
      extParams: {
        type: Object,
        default: () => ({})
      },
      btnIcon: {
        type: String,
        default: 'layout layout-shangchuan'
      },
      btnType: {
        type: String,
        default: 'default-primary'
      },
      btnText: {
        type: String,
        default: BUTTON_TEXT
      },
      disabled: {
        type: Boolean,
        default: false
      },
      beforeUpload: Function,
      accept: Array,
      size: Number,
      replace: Boolean,
      fileId: String,
      attr: Object,
      successMsg: {
        type: String,
        default: '上传成功'
      },
      auth: String,
      validateVideo: Boolean, // 校验视频文件是否加密
      beforeRemoveFn: Function,
      beforeSuccessFn: Function, // 上传成功前回调事件
      areaSize: [Number, String, Array], // 上传区域尺寸，避免业务透传样式冲突,
      tips: {
        type: String,
        default: '支持doc、docx、xls、pdf等常用格式'
      },
      title: {
        type: String,
        default: '点击上传或将文件拖拽到此处'
      },
      maxUploadTips: {
        type: String,
        default: '上传文件数量已达上限'
      },
      loadingText: {
        type: String,
        default: '上传中...'
      },
      showLimit: {
        type: Boolean,
        default: false
      },
      previewOptions: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        count: 0,
        num: 0,
        uploadList: [],
        fileList: [],
        // signature: null,
        accepts: {
          excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/kset',
          word: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/kswps',
          pdf: 'application/pdf, application/kswps',
          image: 'image/gif, image/jpeg, image/png, image/x-ms-bmp',
          zip: 'application/zip, application/x-zip-compressed',

          ppt: `application/vnd.ms-powerpoint,
            application/vnd.ms-powerpoint,
            application/vnd.ms-powerpoint,
            application/vnd.openxmlformats-officedocument.presentationml.template,
            application/vnd.openxmlformats-officedocument.presentationml.slideshow,
            application/vnd.openxmlformats-officedocument.presentationml.presentation`
        },
        isInAccept: true,
        loading: false
      }
    },
    computed: {
      // 历史兼容场景，不能删除
      bindAtrr () {
        return this.attr || this.$attrs
      },
      limitAtrr () {
        return this.bindAtrr['limit']
      },
      showFileListAttr () {
        if (this.bindAtrr.hasOwnProperty('show-file-list')) {
          return this.bindAtrr['show-file-list']
        }
        if (this.bindAtrr.hasOwnProperty('showFileList')) {
          return this.bindAtrr['showFileList']
        }
        return true
      },
      uploadUrl () {
        return `/router/upload`
      },
      fileData () {
        let obj = {
          bizCode: (this.code && typeof this.code === 'string') ? this.code.replace(/\./g, '_') : this.code,
          bizId: this.id,
          num: this.num,
          // signature: this.signature,
          ...this.extParams,
          token: getToken(),
          'x-uid': this.$store.getters.user.id
        }
        if (this.replace) {
          obj.id = this.fileId
        }
        return obj
      },
      currentAccept () {
        if (this.accept) {
          return this.accept.map(k => this.accepts[k] ? this.accepts[k] : k).join(',')
        }
        return ''
      },
      // 兼容泳道环境添加ENV-id
      headers () {
        if (isProd) {
          return {}
        }
        const multiSessionStr = sessionStorage.getItem('ERPMULTIMODULE')
        if (multiSessionStr) {
          const multiSessionData = JSON.parse(multiSessionStr)
          const envId = multiSessionData.envId
          if (envId) {
            return {
              'x-envid': envId
            }
          }
        }
        return {}
      },
      isPictureMode () {
        return this.$attrs['list-type'] === 'picture' // 缩略图展示
      },
      isPictureCardMode () {
        return this.$attrs['list-type'] === 'picture-card' // 缩略图 + 上传卡片
      },
      isNewPictureCardMode () {
        return this.$attrs['list-type'] === 'picture-card2'
      },
      isDragMode () {
        return this.$attrs['list-type'] === 'drag' || this.$attrs['list-type'] === 'drag-side'
      },
      isDragPictureMode () {
        return this.$attrs['list-type'] === 'drag-picture' || this.$attrs['list-type'] === 'drag-picture-side'
      },
      isSide () {
        return this.$attrs['list-type'] === 'drag-side'
      },
      showSideArea () {
        return this.isSide && this.showFileList && this.value.length > 0
      },
      innerListType () {
        if (this.isPictureCardMode) {
          return this.$attrs['list-type']
        }
        return 'text'
      },
      isDrag () {
        if (this.bindAtrr.hasOwnProperty('drag')) {
          return this.bindAtrr['drag'] !== false
        }
        return this.isNewDrag
      },
      isNewDrag () {
        return this.isDragMode || this.isDragPictureMode
      },
      uploadWrapClass () {
        return {
          'is-card': this.isPictureCardMode, // 旧版本card标识
          'is-drag': this.isDrag,
          'is-new-drag': this.isNewDrag,
          'is-fullwidth': this.isFullWidth,
          'is-disabled': this.disableUpload,
          'is-side': this.showSideArea
        }
      },
      uploadListWrapClass () {
        return {
          'kye-scrollbar': this.showSideArea,
        }
      },
      uploadListWrapStyle () {
        if (!this.showSideArea) {
          return {}
        }
        const { areaSize } = this.$props
        let s = areaSize || 132
        if (!Array.isArray(s)) {
          s = [s, s]
        }
        return {
          'height': parseInt(s[1]) + 'px',
        }
      },
      showInnerFileList () {
        if (this.showFileListAttr === false) {
          return false
        }
        return !this.showFileList
      },
      showFileList () {
        if (this.showFileListAttr === false) {
          return false
        }
        if (this.isPictureCardMode) {
          return false
        }
        return true
      },
      showLimitText () {
        const { btnText, showLimit } = this.$props
        if (showLimit) {
          return true
        }
        if (BUTTON_TEXT !== btnText) {
          return false
        }
        if (this.limitAtrr) {
          return !!this.limitAtrr
        }
        return false
      },
      maxUpload () {
        return this.limitAtrr && this.value.length >= this.limitAtrr
      },
      disableUpload () {
        // 内部按钮自定义，由内部决定是否上传
        if (this.isNewPictureCardMode) {
          return this.$props.disabled
        }
        if (this.maxUpload) {
          return true
        }
        if (this.loading) {
          return true
        }
        return this.$props.disabled
      },
      isFullWidth () {
        const { areaSize } = this.$props
        if (!this.isNewDrag) {
          return false
        }
        if (areaSize === '100%') {
          return true
        }
        if (Array.isArray(areaSize) && areaSize[0] === '100%') {
          return true
        }
        return false
      },
      buttonMode () {
        // 优先新版
        if (this.isNewPictureCardMode) {
          return 'card'
        }
        if (this.isNewDrag) {
          return 'drag'
        }
        if (this.isPictureCardMode) {
          return 'oldCard'
        }
        return 'button'
      },
      previewAttrs () {
        const { areaSize } = this.$props
        const isImg = this.isNewPictureCardMode || this.isPictureMode || this.isDragPictureMode
        const defaultValue = (this.isPictureMode || this.isNewDrag) ? 64 : 148
        let config = {
          isPrewFileToPdf: true,
          viewType: isImg ? 'image' : 'list',
          direction: (isImg || this.isSide) ? 'horizontal' : 'vertical',
          itemSize: areaSize || defaultValue,
          placement: this.isNewPictureCardMode ? 'append' : 'prepend',
          ...this.$props.previewOptions
        }
        return config
      }
    },
    watch: {
      // fileList是内部上传限制数量，或者显示上传列表使用(目前功能没用到，采用的是自定义上传列表)
      value: {
        immediate: true,
        handler (val) {
          const successList = val || []
          const uploadList = this.uploadList
          this.fileList = [...uploadList, ...successList]
        }
      }
    },
    mounted () {
      this.isNewDrag && this.$el.addEventListener('paste', this.handlePaste)
    },
    beforeDestroy () {
      this.isNewDrag && this.$el.removeEventListener('paste', this.handlePaste)
    },
    methods: {
      // getSign () {
      //   if (!this.signature) {
      //     this.count = this.count + 1
      //     let params = { args: { code: this.code }, timeout: 300 }
      //     this.$http('openapi.signature', params).then(data => {
      //       this.signature = data
      //     }).catch(err => {
      //       console.log(err)
      //       if (this.count < 4) {
      //         this.getSign()
      //       } else {
      //         this.$message.error('签名失败')
      //       }
      //     })
      //   }
      // },
      handlePaste (e) {
        const clipboardData = e.clipboardData
        if (!clipboardData) {
          return
        }

        const items = clipboardData.items
        const fileList = []
        if (items && items.length) {
          for (var i = 0; i < items.length; i++) {
            var item = items[i]
            if (item.kind === 'file') {
              var file = item.getAsFile()
              if (file) {
                fileList.push(file)
              }
            }
          }
        }

        if (fileList.length === 0) {
          return
        }

        e.preventDefault()

        // 链式调用 uploadFiles
        const upload = this.$refs.upload
        if (upload && upload.$refs && upload.$refs['upload-inner'] && typeof upload.$refs['upload-inner'].uploadFiles === 'function') {
          upload.$refs['upload-inner'].uploadFiles(fileList)
        }
      },
      handleChange (file, list) {
        this.uploadList = list.filter(v => v.status && v.status !== 'success')
        this.num = list.length // 开始为上传中，如果失败，清空失败，最终状态为success
      },
      handleInput(data) {
        this.$emit('input', data)
      },
      handleSuccess (res, file, list) {
        this.loading = false
        this.num = 0
        // 自定义success功回调事件
        const isNext = typeof this.$props.beforeSuccessFn === 'function' ? this.$props.beforeSuccessFn(res, file, list) : true
        if (!isNext) return
        // 上传文件大小为0kb的不往下走
        if (file.size === 0) {
          this.$message.warning(`文件大小不能为0KB!`)
          this.$emit('error', res, file, list)
          this.removeFileList(file)
          return
        }

        if (res.code === 0) {
          // res后端返回数据与list上传列表数据匹配，避免为未上传完的文件被覆盖
          this.uploadList = list.filter(v => v.status && v.status !== 'success')
          this.handleInput(res.data)
          this.$emit('success', res.data, list)
          this.successMsg && this.$message.success(this.successMsg)
        } else {
          this.$emit('error', res, file, list)
          this.$message.warning(res.msg || res.message || '上传失败')
          this.removeFileList(file)
        }
      },
      beforeRemove (file, list) {
        const isNext = typeof this.$props.beforeRemoveFn === 'function' ? this.$props.beforeRemoveFn(file, list) : true
        if (!isNext) return false

        if (file && !(this.size && file.size > this.size * 1024 * 1024) && this.isInAccept && file.status === 'success') {
          return this.$confirm('确定要删除该文件吗？删除后不支持找回。', '提示')
        }
      },
      handleRemove (file, list) {
        if (file && file.bizCode && file.bizId && file.id) {
          let params = { bizCode: file.bizCode, bizId: file.bizId, id: file.id }
          this.$http('file.deleteByBizAndId', params).then(res => {
            if (res) {
              let arr = JSON.parse(JSON.stringify(this.value))
              let index = arr.findIndex(t => t.id === params.id)
              arr.splice(index, 1)
              this.handleInput(arr)
              this.$emit('delete-success', arr)
              this.$message.success('删除成功')
            }
          })
        }
      },
      handlePreview (file) {
        if (this.$attrs['on-preview']) {
          this.$attrs['on-preview'](file)
        } else {
          window.erpOpen(file.url)
        }
      },
      handleBeforeUpload (file) {
        return new Promise(async (resolve, reject) => {
          let isUpload = true
          try {
            if (this.validateVideo) {
              const isEncrypted = await isEncryptedByVideoFile(file)
              if (isEncrypted) {
                isUpload = false
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(false)
                return
              }
            }

            if (this.size && file.size > this.size * 1024 * 1024) {
              this.$message.warning(`文件大小不能超过${this.size}MB!`)
              isUpload = false
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(false)
              return
            }
            if (this.beforeUpload && typeof this.beforeUpload === 'function') {
              let userUpload = this.beforeUpload(file)
              if (userUpload && userUpload.then) {
                userUpload = await userUpload
              }
              if (userUpload === false) {
                isUpload = false
                // eslint-disable-next-line prefer-promise-reject-errors
                reject(false)
                return
              }
            }
          } catch (error) {
            isUpload = false
            reject(error)
          }

          isUpload && (this.loading = true)
          resolve()
        })
        /* if (this.accept && this.accept.length) {
          this.isInAccept = true
          let type = file.type || `.${file.name.split('.').pop()}`
          if (this.currentAccept.indexOf(type) === -1) {
            this.isInAccept = false
            this.$message.warning(`文件类型与要求不符`)
            return false
          }
        } */
      },
      // 手动调用upload上传组件
      manualUpload () {
        this.$refs.upload.$children[0].handleClick()
      },
      deleteFile (item) {
        const index = this.value.findIndex(t => t.id === item.id)
        const before = this.beforeRemove(this.value[index], this.value)
        if (before && before.then) {
          before.then(
            () => {
              this.handleRemove(this.value[index], this.value)
            },
            () => {}
          )
        } else if (before !== false) {
          this.handleRemove(this.value[index], this.value)
        }
      },
      removeFileList (file) {
        const upload = this.$refs.upload
        if (file && upload) {
          const uploadFiles = upload.uploadFiles
          uploadFiles && uploadFiles.splice(uploadFiles.indexOf(file), 1)
        }
      },
      onError () {
        this.loading = false
        const onError = this.bindAtrr['on-error'] || this.bindAtrr['onErrror']
        onError && onError()
      },
      onExceed() {
        this.$message.warning(this.maxUploadTips)
      },
    }
  }
</script>

<style lang="scss">
.kye-upload {
  &-container {
    &.is-fullwidth {
      width: 100%;
      .el-upload {
        width: 100%;
      }
    }
    .el-upload {
      border: none;
      &-dragger {
        border: 2px dashed var(--g-border-color);
        border-radius: var(--g-border-radius);
        &:hover {
          border-color: var(--g-color-primary);
        }
        &.is-dragover {
          background: var(--g-bg-primary);
        }
      }
    }
    &.is-disabled {
      .el-upload {
        cursor: not-allowed;
      }
      .el-upload-dragger {
        cursor: not-allowed;
        border: 2px dashed var(--g-border-color);
        &:hover {
          border-color: var(--g-border-color);
        }
      }
    }
    // 旧版本card兼容
    &.is-card:not(.is-drag) {
      .el-upload {
        background-color: var(--g-bg-gray);
        border: 2px dashed var(--g-border-color);
        border-radius: var(--g-border-radius);
        &:hover {
          border-color: var(--g-color-primary-hover);
          background: var(--g-bg-primary-hover);
        }
        &:active {
          border-color: var(--g-color-primary-active);
          background: var(--g-bg-primary-active);
        }
      }
      &.is-disabled {
        .el-upload {
          background-color: var(--g-bg-gray);
          border-color: var(--g-border-color);
        }
      }
    }

    .kye-preview-file-list-wrapper {
      margin-top: 4px;
    }

    &.is-new-drag {
      .el-upload {
        border: none;
        &-dragger {
          height: auto;
          width: auto;
          &.is-dragover {
            background: transparent;
          }
        }
      }
      &.is-side {
        display: flex;
        .kye-upload-list {
          padding: 16px;
          margin-left: 12px;
          // width: 610px;
          // height: 132px;
          border: 2px solid var(--g-border-color);
          border-radius: var(--g-border-radius);
          overflow: scroll;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-upload/index.vue